























import { Component, Prop, Vue } from 'vue-property-decorator';
import { FormItem, Input } from 'element-ui';

// types
import {
  ShipmentDocumentDataInput,
  ShipmentDocumentFields
} from '@/types/graphql/schemaTypes';
@Component({
  components: {
    'el-form-item': FormItem,
    'el-input': Input
  }
})
export default class ImporterExporterInformation extends Vue {
  @Prop({ type: Object }) value!: ShipmentDocumentDataInput;
  @Prop({ type: Object }) document!: ShipmentDocumentFields;

  get customerName() {
    return this.value.customerName;
  }

  set customerName(data) {
    this.$emit('input', { ...this.value, customerName: data });
  }

  get customerAddress() {
    return this.value.customerAddress;
  }

  set customerAddress(data) {
    this.$emit('input', { ...this.value, customerAddress: data });
  }

  get customerCompanyNumber() {
    return this.value.customerCompanyNumber;
  }

  set customerCompanyNumber(data) {
    this.$emit('input', { ...this.value, customerCompanyNumber: data });
  }

  get customerShipperConsigneeStandardCode() {
    return this.value.customerShipperConsigneeStandardCode;
  }

  set customerShipperConsigneeStandardCode(data) {
    this.$emit('input', { ...this.value, customerShipperConsigneeStandardCode: data });
  }
}
